import React from 'react'
import { Sidebar } from 'primereact/sidebar';
import classes from './Sidebar.module.css';
import {Link, useLocation, useParams} from 'react-router-dom'


const SidebarComponent = ({visible,handle,categories}) => {

    const {category } = useParams()

  const {pathname} = useLocation()
  console.log(pathname)

  return (
    <Sidebar visible={visible} position="left" onHide={handle } className={classes.sidebar}>
    <div>
      <p className={classes.title}>Game Categories</p>
      <ul className={classes.list}>
      {
        <Link to={`/`} style={{textDecoration:'none'}}>
            <li className={`${classes.list_item } ${category == undefined && classes.active}`}>Home</li>
            </Link>
      }
        {
          categories && categories.map((category, index) =>(
            <Link to={`/Category/${category.id}`} key={index} style={{textDecoration:'none'}}>
            <li className={`${classes.list_item } ${category == category?.id && classes.active}`}>{category.name}</li>
            </Link>
          ))
        }
       
      </ul>
    </div>
    </Sidebar>
  )
}

export default SidebarComponent
